const terms = {
  title: '利用規約',
  description: 'Plannelyアプリおよびウェブサイトの利用規約です。アカウント、サブスクリプション、お客様のコンテンツ、サービスの利用ルールについて説明します。',
  effectiveLabel: '発効日：',
  effectiveDate: '2026年11月5日',
  appLabel: 'アプリ：',
  privacyPhrases: ['プライバシーポリシー'],
  sections: [
    {
      title: '本規約への同意',
      body: [
        '本利用規約（以下「本規約」）は、Plannelyモバイルアプリおよびウェブサイト https://plannely.app （以下総称して「本サービス」）のご利用に適用されます。本サービスはSEOTIV（以下「当社」）が提供します。',
        'アカウントを作成するか本サービスを利用することで、お客様は本規約に同意したものとします。同意されない場合は、本サービスを利用しないでください。当社のプライバシーポリシー（https://plannely.app/privacy-policy ）では個人データの取り扱いについて説明しており、本サービスの運営に適用されます。',
      ],
    },
    {
      title: '本サービス',
      body: [
        'Plannelyは個人向けのプランナーです。プラットフォーム、バージョン、プランに応じて、タスク、カテゴリ、習慣、リマインダー、カレンダー表示、集中およびワークアウトのツール、端末間の同期などが含まれる場合があります。',
        '当社は本サービスの発展に伴い、機能を追加、変更または削除することがあります。現在お支払いいただいている有料機能が変更により大幅に制限される場合は、アプリまたはその他の適切な方法で、合理的な期間をもって事前にお知らせするよう努めます。',
      ],
    },
    {
      title: 'お客様のアカウント',
      body: [
        'アプリで提供される方法（GoogleやAppleなど）でログインしていただきます。お客様は、当該アカウントおよび端末へのアクセスの安全管理と、Plannelyアカウントで行われる活動について責任を負います。第三者が許可なくアカウントにアクセスしたと思われる場合は、速やかに support@plannely.app までご連絡ください。',
        '当社に提供する情報が正確であることをご確認ください。本サービスは、お客様に適用される法律で認められる範囲でのみご利用ください。',
      ],
    },
    {
      title: '児童および未成年者',
      body: [
        'お住まいの地域で拘束力のある契約を締結できる年齢に達していない場合は、親または法定後見人の許可と関与のもとでのみ本サービスを利用でき、その方がお客様に代わって本規約に同意するものとします。児童のデータの取り扱いについては、当社のプライバシーポリシー第14条をご覧ください。',
      ],
    },
    {
      title: '無料プランと有料プラン',
      body: [
        'Plannelyには、利用制限のある無料プランと、より高い上限や追加機能を備えた任意の有料サブスクリプションがあります。現在の上限と価格はアプリに表示され、変更されることがあります。無料プランでは、完了したタスクを含め、削除するまでタスクは上限に算入されます。',
        'サブスクリプションは、購入に使用したアカウントを通じてAppleまたはGoogle Playが販売および請求を行います。ストアの規則に加えて、以下が適用されます。',
        [
          'サブスクリプションは、現在の期間が終了する24時間前まで、またはストアが定める期限までに解約しない限り、その時点の価格で同じ期間自動更新されます。',
          '無料トライアルが提供される場合、期限内に解約しない限り、終了時に有料サブスクリプションへ移行します。価格とトライアル期間は購入の確定前に表示されます。',
          'サブスクリプションの管理および解約は、AppleまたはGoogle Playのアカウントで行います。アプリまたはPlannelyアカウントを削除しても解約されません。',
          '返金はストアがそのポリシーに基づいて処理します。当社はストアの決済を処理せず、カード情報の全体を受け取ることもありません。',
        ],
        'サブスクリプションが終了すると、アカウントは無料プランに戻ります。それを理由にデータが削除されることはありませんが、追加の習慣など無料プランの上限を超える機能やコンテンツは、再度登録するまで利用できない場合があります。',
      ],
    },
    {
      title: 'お客様のコンテンツ',
      body: [
        '本サービスで作成したタスク、メモ、習慣、ワークアウトその他のコンテンツ（以下「お客様のコンテンツ」）に関するすべての権利は、お客様が保持します。お客様は、お客様のために本サービスを運営、保護およびサポートするために必要な範囲でのみ、お客様のコンテンツを保存、処理、複製および送信する、限定的、非独占的かつ全世界的なライセンスを当社に付与します。当社はお客様のコンテンツを広告に使用せず、販売もしません。',
        'お客様は、お客様のコンテンツおよびそれを使用する権利を有することについて責任を負います。お客様にとって特に重要なものは、ご自身でもコピーを保管してください。',
        'ワークアウトプログラムの共有リンクを作成すると、リンクの有効期限が切れるか取り消されるまで、リンクを知っている人は誰でもそのプログラムを閲覧およびコピーできます。リンクは信頼できる相手とのみ共有し、共有するコンテンツに個人的な情報を含めないでください。',
      ],
    },
    {
      title: '禁止事項',
      body: [
        '本サービスの利用にあたり、次の行為を行わないことに同意するものとします。',
        [
          '法律または他者の権利を侵害すること。',
          '共有リンクを通じたものを含め、違法、有害または不適切なコンテンツを保存または共有すること。',
          '本サービス、他のアカウントまたは当社のシステムに不正にアクセスし、またはアクセスを試みること。',
          '本サービスを妨害もしくは過負荷にし、またはプランの上限その他の技術的制限を回避すること。',
          'この制限にかかわらず法律で認められる場合を除き、本サービスをリバースエンジニアリングすること。',
          '当社の書面による許可なく、自動化された手段で本サービスからデータを抽出すること。',
          '当社の書面による許可なく、本サービスを再販売または商業的に再配布すること。',
        ],
      ],
    },
    {
      title: 'リマインダーと可用性',
      body: [
        '当社は本サービスの信頼性の維持に努めていますが、リマインダーと同期は、お客様の端末、その設定、ネットワーク、およびAppleやGoogleなどの第三者サービスに左右されます。通知は遅れたり届かなかったりすることがあります。服薬など、通知を見逃すと危害や重大な損失につながるおそれのある事柄については、本サービスを唯一のリマインダーとしないでください。',
        '本サービスは、メンテナンス、アップデート、または当社の管理が及ばない事象により、一時的に利用できない場合があります。',
      ],
    },
    {
      title: '健康とワークアウト',
      body: [
        'ワークアウト、集中、習慣の機能は、一般的なセルフマネジメントのためのツールです。医学的な助言、診断または治療ではありません。運動を始めたり変更したりする前に、特に健康上の問題がある場合は、資格のある医療専門家にご相談ください。痛み、めまい、不快感を覚えた場合は運動を中止してください。法律で認められる範囲で、これらの機能はお客様ご自身の責任でご利用いただきます。',
      ],
    },
    {
      title: '当社の知的財産',
      body: [
        '本サービス（ソフトウェア、デザイン、名称、ロゴを含みます）は当社またはそのライセンサーに帰属し、知的財産法により保護されています。当社はお客様に対し、本規約に従って本サービスを本来の目的で利用するための、個人的、限定的、非独占的、譲渡不能かつ取消可能なライセンスを付与します。お客様のコンテンツはお客様のものです。',
        'お客様から当社にご意見やアイデアをお送りいただいた場合、当社はお客様に対して何らの義務を負うことなくそれらを利用できます。',
      ],
    },
    {
      title: '第三者サービス',
      body: [
        '本サービスは、ログイン、決済、通知、ホスティングなどの機能に第三者を利用しています。第三者が提供するサービスには、それぞれの規約とプライバシーポリシーが適用されます。当社は、当社が管理していない第三者サービスの可用性または行為について責任を負いません。',
      ],
    },
    {
      title: '本サービスの利用終了',
      body: [
        'お客様はいつでも本サービスの利用を停止し、アプリまたは support@plannely.app へのご連絡によりアカウントを削除できます。アカウントの削除については当社のプライバシーポリシーで説明しています。ストアのサブスクリプションは別途解約してください。',
        'お客様が本規約に重大または繰り返し違反した場合、お客様の利用が本サービスまたは他者にリスクをもたらす場合、または法律で求められる場合、当社はアカウントを停止または閉鎖することがあります。適切かつ許される場合は、理由を説明し、問題を解決する機会を提供します。当社が本サービスを終了する場合は、合理的な期間をもって事前にお知らせするよう努めます。',
      ],
    },
    {
      title: '保証の否認',
      body: [
        '法律で認められる最大限の範囲で、本サービスは「現状有姿」かつ「提供可能な範囲」で提供されます。当社は、本サービスが中断なくエラーなく動作すること、特定の目的に適合すること、またはデータが決して失われないことを約束しません。本規約のいかなる内容も、お客様に適用される法律により制限できない保証または消費者の権利を制限するものではありません。',
      ],
    },
    {
      title: '責任の制限',
      body: [
        '法律で認められる最大限の範囲で、当社は、間接的、付随的、特別または結果的な損害、ならびに逸失利益、データの損失または見逃した予定について責任を負いません。有料プランの場合、本サービスに関連するあらゆる請求について当社が負う責任の総額は、請求の原因となった事象の前12か月間にお客様が本サービスに支払った金額を上限とします。無料プランの場合は、50米ドル相当額を上限とします。',
        'これらの制限は、詐欺、故意の不正行為、法律で定められている場合の過失による死亡または身体的傷害など、法律により免責または制限できない責任には適用されません。',
      ],
    },
    {
      title: 'Apple App Storeからダウンロードしたアプリ',
      body: [
        'Apple App StoreからPlannelyをダウンロードした場合、以下の追加条件が適用されます。',
        [
          '本規約はお客様とSEOTIVとの間で締結されるものであり、Appleとの間のものではありません。アプリとそのコンテンツについては、AppleではなくSEOTIVが単独で責任を負います。',
          'お客様のライセンスは、Appleメディアサービス利用規約の利用ルールで認められるとおり、お客様が所有または管理するApple製デバイスでアプリを使用することに限定されます。',
          'Appleは、アプリの保守またはサポートを提供する義務を一切負いません。',
          'アプリが適用される保証に適合しない場合、お客様はAppleに通知でき、Appleは購入代金があればこれを返金します。法律で認められる最大限の範囲で、Appleはアプリに関してその他の保証義務を負いません。',
          'Appleは、製造物責任、法令遵守、消費者保護またはプライバシーに関する請求を含め、アプリまたはその使用に関連する請求に対応する責任を負いません。',
          'Appleは、アプリまたはその使用が知的財産権を侵害するとの第三者の請求について、調査、防御、和解または解決を行う責任を負いません。',
          'お客様は、米国政府の禁輸措置の対象国または「テロ支援」国に指定された国に所在していないこと、および米国政府の禁止または制限対象者リストに掲載されていないことを確認するものとします。',
          'アプリの使用にあたっては、適用される第三者の規約を遵守しなければなりません。',
          'Appleおよびその子会社は本規約の第三者受益者であり、お客様に対して本規約を執行することができます。',
        ],
      ],
    },
    {
      title: '本規約の変更',
      body: [
        '当社は、本サービスまたは法律の変更に応じて本規約を更新することがあります。最新版は発効日とともに常に https://plannely.app/terms で公開されます。重要な変更については、アプリまたはその他の適切な方法で事前にお知らせするよう努めます。変更の発効後も本サービスを利用し続けることで、お客様は更新後の本規約に同意したものとします。同意されない場合は、本サービスの利用を停止し、アカウントを削除してください。',
      ],
    },
    {
      title: '準拠法および紛争',
      body: [
        '問題を非公式に解決できるよう、まず当社にご連絡ください。本規約は、抵触法の規則にかかわらず、SEOTIVが設立された国の法律に準拠します。これにより、お客様の居住国の消費者法に基づく強行的な保護（同法に基づき利用可能な裁判所に提訴する権利を含みます）が奪われることはありません。',
        '本規約の一部が執行不能と判断された場合でも、残りの部分は引き続き適用されます。当社がある規定をただちに執行しない場合でも、後に執行する権利を放棄するものではありません。お客様は、当社の同意なく本規約に基づく権利を譲渡できません。当社は、お客様の権利を減じることなく、本サービスの再編または売却の一環として当社の権利を譲渡できます。',
        '本規約の翻訳は、お客様の便宜のために提供しています。翻訳と英語版に相違がある場合は、お客様の国の法律が別段の定めをしている場合を除き、英語版が優先します。',
      ],
    },
    {
      title: 'お問い合わせ',
      body: [
        '本規約についてご質問がある場合は、support@plannely.app までご連絡ください。',
      ],
    },
  ],
};

export default terms;
